import Swiper from "swiper/bundle";

export default class Carousel {
  constructor(element, extraOptions) {
    this.swiperElement = element.querySelector(".swiper");
    this.swiperButtonPrev = element.querySelector(".swiper-button-prev");
    this.swiperButtonNext = element.querySelector(".swiper-button-next");

    this.swiper = new Swiper(this.swiperElement, {
      grabCursor: true,
      lazy: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: this.swiperButtonNext,
        prevEl: this.swiperButtonPrev,
      },
      ...extraOptions,
    });
  }
}
